import IState from '@/interfaces/IState';
import ITariff from '@/interfaces/ITariff';
import router from '@/router';
import { ActionContext } from 'vuex';

export default async (
    context: ActionContext<IState, IState>,
    {
      form: tariffData,
      routeName = "tariff_create",
    }: { form: ITariff; routeName?: string }
) => {
    if (!tariffData) {
        return Promise.reject('Incorrect tariff data');
    }
    try {
        const newTariff = await context.dispatch('backendTalker', {
            request: routeName === 'subscription_tariff_create' ? 'subscriptions_tariffs_create' : 'tariff_create',
            data: tariffData
        });
        if (newTariff.status === 201) {
            router.push({ name: routeName === 'subscription_tariff_create' ? 'subscriptions_tariffs' : 'tariffs' });
        } else {
            return Promise.reject(newTariff.status);
        }
    } catch (err) {
        return Promise.reject(err);
    }
};
